import { Brand as TypeBrand, createBranded } from '@deltasierra/type-utilities';
import { PlatformId } from '../platform/Platform';
import { HasId, FullAuditable } from '../common';

export type HashtagSetId = TypeBrand<number, 'HashtagSetId'>;
export const HashtagSetId = createBranded<HashtagSetId>();

export interface HashtagSet extends HasId<HashtagSetId>, FullAuditable {
    title: string;
    description: string;
    hashtags: string[];
    platformId: PlatformId | null;
}
